import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import VImageInput from "vuetify-image-input";
Vue.component(VImageInput.name, VImageInput);

Vue.config.productionTip = false;

import AuthService from "./authService/AuthService.js";
const auth = new AuthService();
Vue.prototype.$authService = auth;

import axios from "axios";
var axiosTemp = axios.create({ baseURL: store.getters.getBackendIpAddress });
Vue.prototype.$axios = axiosTemp;

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import { VueQueryPlugin } from "@tanstack/vue-query";
Vue.use(VueQueryPlugin);

import { VLazyImagePlugin } from "v-lazy-image";
Vue.use(VLazyImagePlugin);

import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
Vue.use(VueQuillEditor);

// import moment from 'moment'
import moment from "moment-timezone";
Object.defineProperty(Vue.prototype, "$moment", { value: moment });

//import global helpers instead of defining in each component
import unitConvert from "@/globalHelpers/unitConvert.js";
import timezoneConvert from "@/globalHelpers/timezoneConvert.js";
import evtFormulation from "@/globalHelpers/evtFormulation.js";
import fftFormulation from "@/globalHelpers/fftFormulation.js";
import exportFunctions from "@/globalHelpers/exportFunctions.js";
import nutrientFormulation from "@/globalHelpers/nutrientFormulation.js";
import helperFunctions from "@/globalHelpers/helperFunctions.js";

Vue.mixin(unitConvert);
Vue.mixin(timezoneConvert);
Vue.mixin(evtFormulation);
Vue.mixin(fftFormulation);
Vue.mixin(nutrientFormulation);
Vue.mixin(helperFunctions);
Vue.mixin(exportFunctions);

import SubmitButton from "@/components/customComponents/SubmitButton.vue";
Vue.component("submit-button", SubmitButton);

import "echarts";
import ECharts from "vue-echarts"; // refers to components/ECharts.vue in webpack
// register component to use
Vue.component("v-chart", ECharts);

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";

Vue.component("VueSlider", VueSlider);

Vue.prototype.$window = window;

import i18n from "./i18n";

import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(store.getters.getAgGridLicenseKey);
Vue.component("AgGridVue", AgGridVue);

// import i18n from './i18n'

new Vue({
 vuetify,
 router,
 store,
 i18n,
 render: h => h(App),
}).$mount("#app");
